/** Сколько штатных connect_error подряд чтобы зарепортить ошибку при первом коннекте */
export const INITIAL_EXPECTED_CONNECT_ERROR_REPORT_THRESHOLD = 3

/** Ошибки при вызове emit, когда сокет уже закрыт */
export const SENTRY_IGNORED_WSS_EMIT_ERRORS = [
  /^socket has been disconnected$/,
  /^WebSockets disconnected$/,
  /^No connection$/
]

/** Штатные ошибки Socket.IO — клиент не открыл соединение (сервер не ответил или браузер закрыл WS) */
export const EXPECTED_CONNECT_ERROR_PATTERNS = [
  /^websocket error$/,
  /^timeout$/
]
